import React from "react";
import { arrayOf, shape, string, func, object, bool } from "prop-types";
import { connect } from "react-redux";
import Onboarding from "../components/CPI/CpiOnboarding";
import { markDocumentReadCPI } from "../redux/actions";
import { manualHandlingSubmitted } from "../redux/actions/formActions";

const CpiOnboardingContainer = ({
  appData,
  readingListDownloads,
  cpiOnboarding,
  cpiReadingLoading,
  markDocumentReadFunc,
  setManualHandlingSubmitted,
}) => {
  return (
    <Onboarding
      appData={appData}
      readingList={readingListDownloads}
      cpiOnboarding={cpiOnboarding}
      markDocumentRead={markDocumentReadFunc}
      cpiReadingLoading={cpiReadingLoading}
      setManualHandlingSubmitted={setManualHandlingSubmitted}
    />
  );
};

CpiOnboardingContainer.propTypes = {
  appData: object.isRequired,
  markDocumentReadFunc: func.isRequired,
  cpiOnboarding: object,
  cpiReadingLoading: bool,
  setManualHandlingSubmitted: func,
  readingListDownloads: arrayOf(
    shape({
      title: string.isRequired,
      link: string.isRequired,
    })
  ),
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
  readingListDownloads: state.core.umbracoContent.cpiReadingList,
  cpiOnboarding: state.core.app.cpiOnboarding,
  cpiReadingLoading: state.core.cpiReading.isReadingLoading,
});

const mapDispatchToProps = {
  markDocumentReadFunc: markDocumentReadCPI,
  setManualHandlingSubmitted: manualHandlingSubmitted,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(CpiOnboardingContainer);
